'use strict';

import $ from 'jquery';
import storage from './storage';

const seasonDependingContent = {

  $seasonDepending: null,
  geoSeason: null,

  init: function(){
    console.log('seasonDependingContent.init()');

    this.$seasonDepending = $('.season-depending');

    if( !this.$seasonDepending.length ) {
      return;
    }

    if( storage.session ){
      this.geoSeason = sessionStorage.getItem('geo_season') || false;
    }

    this.$seasonDepending.hide();

    if( !this.geoSeason ){
      $.ajax({
        url: '/stage-ajax/geo-season/',
        dataType: 'json',
        method: 'GET',
        context: this,
        success: function(res){
          if( res.season ){
            this.geoSeason = res.season.toLowerCase();
            this.showSeasonContent(this.geoSeason);
            if( storage.session ){
              sessionStorage.setItem('geo_season', this.geoSeason);
            }
          }
        }
      });
    }
    else if( this.geoSeason ){
      this.showSeasonContent(this.geoSeason);
    }

  },
  showSeasonContent: function(season){
    this.$seasonDepending.filter('.' + season).removeClass('hidden').show();

    // For some season-depending links there is an added class "fallback".
    // If chosen geo-ip-season's link is not available (for example "Van tyres" do not have 'all season' tires @ en_US)
    // then the whole link disappears. We cannot have that.
    // .fallback class to the rescue!
    // This loops thru .season-depending.fallback links and checks if the do not have any visible siblings.
    // If not, then it shows the .fallback link (e.g. /tires/van-tires/winter-tires/)
    this.$seasonDepending.filter('a.fallback').each(function(){
      if( !$(this).siblings('a.season-depending').not('.hidden').length ) $(this).show().toggleClass('hidden',false).toggleClass('fallback-active',true);
    });

    // Show all the elements in editor
    if($('.stage-editor').length ){
      $('.season-depending.stage-editor').show();
    }
  }
};

export default seasonDependingContent;
